/**
 * GridMasonryLayout Component
 * Pinterest-style staggered layout for shop products
 */

import React from 'react';
import ProductCard from './ProductCard';
import './GridMasonryLayout.css';

function GridMasonryLayout({
  products,
  onProductClick,
  themeColors,
  formatPrice,
  productsPerRow = 4,
  cardStyle = 'standard',
  isNavigating = false,
  onAddToCart,
  renderAdPlacement,
  adInterval = 6,
}) {
  return (
    <div
      className="gml-masonry"
      style={{ '--gml-columns': productsPerRow }}
    >
      {products.map((product, index) => (
        <React.Fragment key={product.id || product._id}>
          {/* Insert ad placement after every N products */}
          {renderAdPlacement && index > 0 && index % adInterval === 0 && renderAdPlacement(index)}
          <div className="gml-item">
            <ProductCard
              product={product}
              onClick={onProductClick}
              themeColors={themeColors}
              formatPrice={formatPrice}
              cardStyle={cardStyle}
              isNavigating={isNavigating}
              onAddToCart={onAddToCart}
            />
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default GridMasonryLayout;
